export default function SubmitOnEnterPlugin(onSubmit) {
  return {
    onKeyDown(evt, editor, next) {
      const metaIncluded = !!evt.metaKey || !!evt.shiftKey || !!evt.altKey;
      if (evt.key === 'Enter' && !metaIncluded) {
        onSubmit(evt);
        return true;
      }
      return next();
    },
  };
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/text_editor/plugins/submit_on_enter.js